<template>
  <div class="conference-layout">
    <conference-images></conference-images>
    <search-box></search-box>
    <div class="main-detail">
      <gallery-carousel></gallery-carousel>
      <div class="information">
        <div>
          <p class="head-main">
            ห้องประชุม และ พื้นที่สำหรับจัดงานสัมมนา ใจกลางเมืองกรุงเทพฯ
          </p>
          <p class="mt-3 main-description">
            CC Conference Centre ให้บริการสถานที่ จัดอบรม สัมมนา ประชุม
            มีให้คุณได้เลือกหลากหลายโซนด้วยกัน มีตั้งแต่ห้องประชุมขนาดเล็ก กลาง
            และ ใหญ่ หรือจัด workshop ต่าง ๆ
            ไปจนถึงบรรยากาศการประชุมที่ไม่วุ่นวาย เป็นส่วนตัว
            พร้อมสิ่งอำนวยความสะดวกอย่าง ที่จอดรถ , Wi-fi
            และอุปกรณ์ที่ใช้ในการประชุม / สัมมนา ที่สามารถรองรับได้มากสุดถึง 350
            คน มีห้องให้เลือกหลายแบบหลายสไตล์ โดยทุกห้องสามารถออกแบบ
            และจัดแต่งให้เหมาะกับแต่ละองค์กรได้
            สามารถเลือกจัดกิจกรรมได้หลากหลายรูปแบบ
            พร้อมให้บริการอาหารและเครื่องดื่ม รวมทั้งยังมีอุปกรณ์ Audio & Video
            และระบบแสงที่ทันสมัยให้ได้ใช้สอย
          </p>
        </div>
        <div class="main-icon icon-width mt-4 row">
          <div
            v-for="(mainIcon, indexIcon) in mainIcons"
            :key="indexIcon"
            class="col-6 mb-5"
          >
            <div class="row">
              <div class="col-4 center">
                <img :src="mainIcon.icon" alt="" />
              </div>
              <div class="col-8 icon-name">
                {{ mainIcon.iconName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="room-type-title">
        <figure>
          <img
            :src="'/static/pictures/mock/room-type.jpg'"
            alt=""
            class="img-store"
            height="470"
          />
        </figure>
        <div class="room-title">
          <div class="box">
            <div class="title-header">Room types</div>
            <div class="detail">
              มีห้องให้เลือกหลายแบบหลายสไตล์ หลากหลายโซนด้วยกัน
              มีตั้งแต่ห้องประชุมขนาดเล็ก กลาง และ ใหญ่ หรือจัด workshop ต่าง ๆ
              ไปจนถึง ห้อง Auditorium ที่สามารถรองรับได้มากสุดถึง 350 คน
              โดยมีบรรยากาศการประชุมไม่วุ่นวาย เป็นส่วนตัว
              พร้อมสิ่งอำนวยความสะดวกอย่าง Wi-fi และอุปกรณ์ที่ใช้ในการประชุม /
              สัมมนา โดยทุกห้องสามารถออกแบบ และจัดแต่งให้เหมาะกับแต่ละองค์กรได้
              สามารถเลือกจัดกิจกรรมได้หลากหลายรูปแบบ
              พร้อมให้บริการอาหารและเครื่องดื่ม รวมทั้งยังมีอุปกรณ์ Audio &
              Video และระบบแสงที่ทันสมัยให้ได้ใช้สอยอย่างครบอีกด้วย
            </div>
          </div>
        </div>
      </div>
    </div>
    <booking-items
      :conference-project-list="conferenceProjectList"
      class="booking-item mb-4"
    ></booking-items>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import BookingItems from "../components/BookingItems"
import GalleryCarousel from "../components/GalleryCarousel"
import SearchBox from "../components/SearchBox"
import ConferenceImages from "../components/ConferenceImages"

export default {
  components: {
    "booking-items": BookingItems,
    "gallery-carousel": GalleryCarousel,
    "search-box": SearchBox,
    "conference-images": ConferenceImages,
  },
  props: [],
  data() {
    const mainPage = [
      "/static/pictures/mock/main-image-static.jpg",
      "/static/pictures/mock/main-image-static.jpg",
    ]

    const mainIcons = [
      {
        icon: "/static/icons/parking-icon.svg",
        iconName: "Parking space",
      },
      {
        icon: "/static/icons/wi-fi-icon.svg",
        iconName: "High speed internet",
      },
      {
        icon: "/static/icons/location-icon.svg",
        iconName: "Accessible location",
      },
      {
        icon: "/static/icons/food.svg",
        iconName: "House keeper",
      },
      {
        icon: "/static/icons/projector-icon.svg",
        iconName: "Audio & Video equipments",
      },
      {
        icon: "/static/icons/material-cleaning-icon.svg",
        iconName: "Food & beverage services",
      },
      {
        icon: "/static/icons/receptionist-icon.svg",
        iconName: "Receptionist",
      },
      {
        icon: "/static/icons/guard-icon.svg",
        iconName: "Guard",
      },
    ]

    return {
      mainPage,
      mainIcons,
      conferenceProjectList: [],
    }
  },
  computed: {},
  created() {
    this.setupConferenceProjectList()
  },
  methods: {
    async setupConferenceProjectList() {
      this.conferenceProjectList = await this.fetchConferenceProjectList()
    },
    async fetchConferenceProjectList() {
      try {
        return await baanRueJaiClient.others.conference.getConferenceProjectList()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        return []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.conference-layout {
}

.main-image {
  position: relative;
}

.main-pic {
  padding-bottom: 20px;
}

$radius-top: 20px 20px 0px 0px;
$radius-button: 0px 0px 20px 20px;

.img-store {
  width: 100%;
}

.main-detail {
  padding-left: 24px;
  padding-right: 25px;
  padding-top: 20px;
  row-gap: 20px;
  display: grid;
}

.head-main {
  color: $color-orange;
  font-size: clamp(40px, 2.5vw, 70px);
  line-height: clamp(60px, 3vw, 66px);

  font-weight: bold;
}

.main-icon {
  margin: auto;
  font-weight: bold;
  text-align: left;
}

.icon-width {
  padding: 20px;
  font-size: $font-16;
}

.type-image-title {
  width: 100%;
  height: 100%;
}

.room-type-title {
  padding-top: 15px;
  padding-bottom: 1px;
  position: relative;
  height: 100%;
  width: 100%;
}

.room-title {
  position: absolute;
  height: 100%;
  width: 30%;
  background: $color-orange;
  top: 0;
  right: 7%;
  opacity: 0.9;
}

.box {
  text-align: left;
  padding-top: 15%;
  color: $white;
  padding-left: 5%;

  .detail {
    padding-right: 20px;
    font-size: 17px;
  }
}

.title-header {
  font-size: 40px;
  color: $white;
  padding-bottom: 8px;
}

.main-description {
  font-size: 17px;
}

.center,
.main-list-icon {
  text-align: center;
}

.center {
  text-align: center;
  margin: auto;
}

.icon-name {
  margin: auto;
}

.booking-item {
  padding-left: 10%;
  padding-right: 10%;
}

@media screen and (min-width: $l-size) {
  .main-detail {
    padding-left: 90px;
    padding-right: 90px;
    padding-top: 50px;
    grid-gap: 20px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: $l-size) {
  .head-main {
    font-size: 30px;
    line-height: 40px;
  }

  .room-title {
    width: 100%;
    font-size: $font-16;
    right: 0;
  }

  .main-description {
    font-size: $font-16;
  }
}

@media screen and (max-width: $m-size) {
  .icon-width {
    padding: 20px;
    font-size: $font-14;
  }
}

@media screen and (max-width: $sm-size) {
  .icon-width {
    padding: 5px;
    font-size: $font-14;
  }
}

@media screen and (max-width: $s-size) {
  .icon-width {
    font-size: $font-12;
  }
}
</style>
